export default {
  en: {
    SEARCH: 'Search',
    UPDATED: 'Updated',
    YES: 'Yes',
    NO: 'No',
    CONFIRM: 'Confirm',
    DELETE: 'Delete',
    EDIT: 'Edit',
    DUPLICATE: 'Duplicate',
    RESET: 'Reset',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    CREATE: 'Create',
    UPDATE: 'Update',
    CONTINUE: 'Continue',
    REQUIRED: 'Required',
    ADD: 'Add',
    LEARN_MORE: 'Learn More',
    VIEW: 'View',
    N_A: 'N/A',
    MATCHED: 'Matched',
    NOT_MATCHED: 'Not Matched',
    NEW: 'New',
    SHOW_REFERENCES: 'Show References',
    REFERENCES: 'References',
    DEFAULT: 'Default',
    LOW: 'Low',
    HIGH: 'High',
    STABLE: 'More Calls',
    REACTIVE: 'Less Calls',
    ALWAYS: 'Always',
    CLOSED: 'Closed',
    OPEN: 'Open',
    PAUSED: 'Paused',
    PAUSE: 'Pause',
    COPY: 'Copy',
    REQUEST: 'Request',
    DOWNLOAD: 'Download',
    SECONDS: 'seconds',
    LOADING: 'Loading...',
    VERIFY: 'Verify',
    BROWSE: 'Browse',
    MALE: 'Male',
    FEMALE: 'Female',
    COUNTRY: 'Country',

    'uiv.modal.cancel': 'Cancel',
    'uiv.modal.ok': 'Yes',

    CAMPAIGN: 'Campaign',
    PUBLISHER: 'Publisher',
    TARGET: 'Target',
    LIVE: 'Live',
    COMPLETED: 'Completed',
    COMPLETED_NO_CONVERSION: 'Completed - without Conversion',
    CONVERTED: 'Converted',
    PAID_OUT: 'Paid Out',
    BLOCKED: 'Blocked',
    NOT_CONNECTED: 'Call Not Connected',
    BLOCK_NUMBER: 'Block Number',
    BLOCK_NUMBERS: 'Block Numbers',
    UNBLOCK_NUMBER: 'Unblock Number',
    ANNOTATE: 'Annotate',
    DURATION_HOURS_UNIT: 'Hours',
    SPECIFY_DURATION_LABEL: 'Specify Duration',
    SPECIFY_DURATION_TT: 'Block the caller for a specific time period',

    INPUT_NO_FILE: 'No file chosen',

    CUSTOMIZE_COLUMNS: 'Customize Columns',
    RESET_COLUMN_STATE: 'Reset Columns',

    EXPORT_CSV: 'Export CSV',

    EXPORT_JSON_SETTINGS: 'Export JSON Settings',

    START_TOUR: 'Start Tour',
    PARTIAL_DATA_SET_MESSAGE: `Partial data displayed. Please use filters to limit the scope of the query. Note: Partial data may also be less accurate.`,
    PARTIAL_DATA_SET_DATE_RANGE_MESSAGE: `Partial data displayed. Please use date range filters to limit the scope of the query. Note: Partial data may also be less accurate.`,

    LABEL_NAME: 'Name',
    LABEL_TYPE: 'Type',
    LABEL_ID: 'ID',

    BETA_TEXT: 'Beta',
    USER_TEXT: 'User',

    TABLE_COL_ACTIONS: 'Actions',
    ORP_GENERIC_ERROR:
      'Something went wrong, could not join as {applicantType}',
    ERROR_CODE_TEXT: 'Error Code',

    METHOD: 'Method',
    STATUS: 'Status',
    ACTIONS: 'Actions',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    ENABLE: 'Enable',

    THANK_YOU: 'Thank you',
    CLOSE: 'Close',

    VIEW_ACTIVITY_TEXT: 'View Activity',
    VIEW_CAMPAIGN_TEXT: 'View Campaign',
    ADVANCED_TEXT: 'Advanced',
    BASIC_TEXT: 'Basic',

    TOKEN: 'Token',
    TOKEN_NOT_AVAILABLE_TT:
      'This token may not be available when the selected event is triggered.',
    REFRESH_TOKEN: 'Refresh Token',

    NUMBER_TF: 'Toll Free',
    NUMBER_DID: 'DID',
    BACK: 'Back',
    CONCURRENCY_SCHEDULE_WARNING_TT:  'The Open time is later than the Close time, which pushes the Close time to the next calendar day. Example:, <b>Open 7PM, Close 7AM</b> means the work shift starts at 7PM and ends at 7AM the next day. <br/> Progress toward daily caps resets at midnight. You should inform your Buyer the cap applies to the calendar day and progress will reset during their work shift.',
    SAME_TIME_SCHEDULE_WARNING_BASIC_TT: 'The Open and Close time are the same, which indicates the target is always open.',
    SAME_TIME_SCHEDULE_WARNING_ADVANCED_TT: 'The Open and Close time are the same, which indicates a 24-hour shift and pushes the Close time to the next calendar day. Example: Open 7AM, Close 7AM means the work shift starts at 7AM and ends at 7AM the next day. Progress toward daily caps resets at midnight. You should inform your Buyer the cap applies to the calendar day and progress will reset during their work shift.',
    PARSE_TYPE: 'Parsing Type',
    PARSE_TYPE_TT: 'Parsing Type',
    PARSE_EXPRESSION: 'Parsing Expression',
    PARSE_EXPRESSION_TT: 'Parsing Expression',
    ADD_PARSE_STEP: 'Add Parsing Step',
    NO_HEADERS: 'No Headers',
    KEY_VALUE_REQUIRED: 'Key and Value are required',

    URL: 'URL',
    VALIDATE: 'Validate',
    PIXELS: 'Pixels',

    ACCOUNT_SETTINGS: 'Account Settings',
    OVERRIDE: 'Override',
    CLICK_TO_EDIT: 'Click to edit',

    RING_TREE_TARGETS: 'Ring Tree Targets',

    CALL_FLOW_ERROR_UNAVAILABLE: 'This node is unavailable.',
    CALL_FLOW_ERROR_INACCESSIBLE:
      'This node is not accessible in the current call flow.',
    CALL_FLOW_ERROR_MISSING: 'This node is missing a required connection.',
    CALL_FLOW_ERROR_ROUTES: 'One or more route filters are invalid.',

    HTTP_URL: 'URL',
    HTTP_URL_TT: 'URL to send the ping request to 3rd-party API endpoint.',
    HTTP_METHOD: 'HTTP Method',
    HTTP_METHOD_TT: 'HTTP Method to be used when sending the ping request to 3rd-party API endpoint.',
    HTTP_AUTHENTICATION: 'Authentication',
    HTTP_AUTHENTICATION_TT: 'Authentication to send along with the request.',
    HTTP_BODY: 'Request Body',
    HTTP_BODY_TT: 'Valid JSON to be used when sending the ping request to 3rd-party API endpoint.',
    HTTP_HEADERS: 'Headers',
    HTTP_HEADERS_TT: 'HTTP Headers to be used when sending the ping request to 3rd-party API endpoint.',
    ERROR_INVALID_JSON: 'Valid JSON Required',
    MESSAGE_HTTP_REQUEST_SUCCESS: 'Add parse settings to complete the Ring Tree Target configuration.',
    MESSAGE_HTTP_REQUEST_FAILED: 'Failed request. Verify the URL and request settings are correct.',

    AUTHENTICATION_PLACEHOLDER: 'Choose Authentication',
    BUTTON_RUN_REQUEST: 'Run Request',
    BUTTON_REVERT: 'Revert Unsaved Changes',
    HEADING_SAMPLE_TOKENS: 'Test Token Values',
    HTTP_VIEW_RESPONSE: 'View Response',
    HTTP_VIEW_ERROR: 'View Error',

    STATS_DAY: 'Day',
    STATS_HOUR: 'Hour',
    STATS_LIVE: 'Live',
    STATS_MONTH: 'Month',
    STATS_TOTAL: 'Total',
    STATUS_HEADER: 'Status',
    STATUS_TEXT: 'Status',
    ACTION_SUCCESS_MESSAGE: 'Action has been performed successfully',
    ACTIONS_COLUMN_HEADER: 'Actions',

    RESET_CAP_COUNTERS: 'Reset Caps',
    RESET_COUNTERS_MODAL_BODY_WITH_NAME:
      'Resetting {target} Cap counters will reset all call counters related to <strong>{targetName}</strong>. Including: All time, Monthly, Weekly, Daily, etc. Are you sure you want to proceed?',
    RESET_COUNTERS_MODAL_BODY:
      'Resetting {target} Cap counters will reset all call counters related to this {target}. Including: All time, Monthly, Weekly, Daily, etc. Are you sure you want to proceed?',
    RESET_COUNTERS_MODAL_HEADER: 'Reset {target} Cap Counters',
    RESET_COUNTERS_MODAL_YES: 'Yes, reset counters',
    RESET_COUNTERS_SUCCESS: 'Cap Counters reset successfully',

    BUYERS_STATUS_CAPPED: 'Buyer Capped',
    BUYERS_STATUS_CC_HIT: 'Buyer has hit the concurrency Cap',
    BUYERS_STATUS_CLOSED: 'Closed',
    BUYERS_STATUS_DISABLED: 'Disabled',
    BUYERS_STATUS_OPEN: 'Open',
    BUYER_EXTRA_TAGS_SELECT_A_TAG: 'Select a tag',

    DELETE_PING_TREE_MODAL_VIEW_TARGET: 'View Ring Tree',

    ERPC: 'Estimated Revenue',
    USE_ERPC: 'Use Estimated Revenue',
    USE_ERPC_TT:
      'Use the parent settings, or override with custom settings to determine how the Estimated Revenue Per Call will be calculated, or enable to use the current revenue for the target',
    USE_CAMPAIGN_SETTING: 'Use Campaign Setting',
    RPC_SETTING_TITLE: 'Predictive Routing Settings',
    RPC_SETTING_TITLE_TT:
      'Predictive Routing settings are used to customize how the Estimated Revenue Per Call will be calculated at routing.',

    COPY_TRANSCRIPT: 'Copy Transcript',
    TRANSCRIPTION_CALLER: 'Caller',
    TRANSCRIPTION_TARGET: 'Target',
    TRANSCRIPTION_LOADING: 'Loading Transcript',
    TRANSCRIPTION_ERROR: 'Error Loading Transcript',
    TRANSCRIBE: 'Transcribe',
    TRANSCRIPTION: 'Transcript',
    TRANSCRIPT_COST: 'Cost',
    TRANSCRIPT_URL: 'URL',
    TRANSCRIPTION_AVAILABLE: 'This call is eligible for transcription.',
    TRANSCRIPTION_PENDING: 'The call transcript is pending and will appear here when available.',
    TRANSCRIPTION_EMPTY: 'The recording contains no spoken words.',

    INSTANT_CALLER_PROFILE_COST: 'Instant Caller Profile (ICP) cost',
    INSTANT_CALLER_PROFILE_DESCRIPTION: 'Each ICP request charges your account at the above rate, regardless of whether the call occurs. These charges are non-refundable.',
    INSTANT_CALLER_PROFILE_TIP: '<strong>Tip:</strong> Your account can be charged more than once for the same call if you receive multiple bids for that call. Ringba recommends using the settings in the <strong>Rate Limit</strong> section on this screen to help you control the number of bids per publisher and manage your costs for ICP requests.',
    INSTANT_CALLER_PROFILE_ATTEST: 'I understand that each ICP request incurs a charge, and I acknowledge that these costs are non-refundable.',

    CONFIRM_PRICING: 'Confirm Pricing',
    CONFIRM_PRICING_ATTEST: 'I confirm the pricing.',

    TARGETS_STATUS_OPEN: 'Open',
    TARGETS_STATUS_CLOSED :  'Closed',
    TARGETS_STATUS_DISABLED: 'Disabled',

    USE_PARENT_SETTING: 'Use Parent Setting',
    USE_BUYER_SETTING: 'Use Buyer Setting',
  }
};
